export const REQUEST_APPRAISERLIST = "REQUEST_APPRAISERLIST";
export const RECEIVE_APPRAISERLIST = "RECEIVE_APPRAISERLIST";
export const ERROR_APPRAISERLIST = "ERROR_APPRAISERLIST";
export const CASEFILTER_CLEARFILTER = "CASEFILTER_CLEARFILTER";

export const REQUEST_APPRAISER = "REQUEST_APPRAISER";
export const RECEIVE_APPRAISER = "RECEIVE_APPRAISER";
export const ERROR_APPRAISER = "ERROR_APPRAISER";

export const REQUEST_APPRAISER_MANAGERS = "REQUEST_APPRAISER_MANAGERS";
export const RECEIVE_APPRAISER_MANAGERS = "RECEIVE_APPRAISER_MANAGERS";
export const ERROR_APPRAISER_MANAGERS = "ERROR_APPRAISER_MANAGERS";

export const REQUEST_VALUATION_COORDINATORS = "REQUEST_VALUATION_COORDINATORS";
export const RECEIVE_VALUATION_COORDINATORS = "RECEIVE_VALUATION_COORDINATORS";
export const ERROR_VALUATION_COORDINATORS = "ERROR_VALUATION_COORDINATORS";

export const REQUEST_VALUATION_DIRECTORS = "REQUEST_VALUATION_DIRECTORS";
export const RECEIVE_VALUATION_DIRECTORS = "RECEIVE_VALUATION_DIRECTORS";
export const ERROR_VALUATION_DIRECTORS = "ERROR_VALUATION_DIRECTORS";

export const REQUEST_APPRAISER_CERTIFICATE = "REQUEST_APPRAISER_CERTIFICATE";
export const RECEIVE_APPRAISER_CERTIFICATE = "RECEIVE_APPRAISER_CERTIFICATE";
export const ERROR_APPRAISER_CERTIFICATE = "ERROR_APPRAISER_CERTIFICATE";

export const REQUEST_APPRAISER_DESIGNATION = "REQUEST_APPRAISER_DESIGNATION";
export const RECEIVE_APPRAISER_DESIGNATION = "RECEIVE_APPRAISER_DESIGNATION";
export const ERROR_APPRAISER_DESIGNATION = "ERROR_APPRAISER_DESIGNATION";

export const REQUEST_APPRAISER_STATE = "REQUEST_APPRAISER_STATE";
export const RECEIVE_APPRAISER_STATE = "RECEIVE_APPRAISER_STATE";
export const ERROR_APPRAISER_STATE = "ERROR_APPRAISER_STATE";

export const REQUEST_APPRAISER_UPDATE = "REQUEST_APPRAISER_UPDATE";
export const RECEIVE_APPRAISER_UPDATE = "RECEIVE_APPRAISER_UPDATE";
export const ERROR_APPRAISER_UPDATE = "ERROR_APPRAISER_UPDATE";

export const REQUEST_USER_LOGIN = "REQUEST_USER_LOGIN";
export const RECEIVE_USER_LOGIN = "RECEIVE_USER_LOGIN";
export const ERROR_USER_LOGIN = "ERROR_USER_LOGIN";

export const REQUEST_USER_REGISTRATION = "REQUEST_USER_REGISTRATION";
export const RECEIVE_USER_REGISTRATION = "RECEIVE_USER_REGISTRATION";
export const ERROR_USER_REGISTRATION = "ERROR_USER_REGISTRATION";

export const REQUEST_AVAILABLE_COMPANIES = "REQUEST_AVAILABLE_COMPANIES";
export const RECEIVE_AVAILABLE_COMPANIES = "RECEIVE_AVAILABLE_COMPANIES";
export const ERROR_AVAILABLE_COMPANIES = "ERROR_AVAILABLE_COMPANIES";

export const SAVE_BROKER_SETTINGS = "SAVE_BROKER_SETTINGS";
export const RECEIVE_BROKER_SAVE_SETTINGS = "RECEIVE_BROKER_SAVE_SETTINGS";
export const ERROR_BROKER_SAVE_SETTINGS = "ERROR_BROKER_SAVE_SETTINGS";

export const SAVE_BROKER_COMPANIES = "SAVE_BROKER_COMPANIES";
export const RECEIVE_BROKER_SAVE_COMPANIES = "RECEIVE_BROKER_SAVE_COMPANIES";
export const ERROR_BROKER_SAVE_COMPANIES = "ERROR_BROKER_SAVE_COMPANIES";

export const SAVE_BROKER_CORRESPONDENT = "ERROR_BROKER_SAVE_COMPANIES";
export const RECEIVE_BROKER_SAVE_CORRESPONDENT = "ERROR_BROKER_SAVE_COMPANIES";
export const ERROR_BROKER_SAVE_CORRESPONDENT = "ERROR_BROKER_SAVE_COMPANIES";

export const REQUEST_BROKER_SETTINGS = "REQUEST_BROKER_SETTINGS";
export const RECEIVE_BROKER_SETTINGS = "RECEIVE_BROKER_SETTINGS";
export const ERROR_BROKER_SETTINGS = "ERROR_BROKER_SETTINGS";

export const REQUEST_FORGOT_PASSWORD = "REQUEST_FORGOT_PASSWORD";
export const RECEIVE_FORGOT_PASSWORD = "RECEIVE_FORGOT_PASSWORD";
export const ERROR_FORGOT_PASSWORD = "ERROR_FORGOT_PASSWORD";

export const REQUEST_USER_PROFILE = "REQUEST_USER_PROFILE";
export const RECEIVE_USER_PROFILE = "RECEIVE_USER_PROFILE";
export const ERROR_USER_PROFILE = "ERROR_USER_PROFILE";

export const REQUEST_USER_PROFILE_UPDATE = "REQUEST_USER_PROFILE_UPDATE";
export const RECEIVE_USER_PROFILE_UPDATE = "RECEIVE_USER_PROFILE_UPDATE";
export const ERROR_USER_PROFILE_UPDATE = "ERROR_USER_PROFILE_UPDATE";

export const REQUEST_CHANGE_PASSWORD = "REQUEST_CHANGE_PASSWORD";
export const RECEIVE_CHANGE_PASSWORD = "RECEIVE_CHANGE_PASSWORD";
export const ERROR_CHANGE_PASSWORD = "ERROR_CHANGE_PASSWORD";

export const REQUEST_USER_LOGOUT = "REQUEST_USER_LOGOUT";
export const RECEIVE_USER_LOGOUT = "RECEIVE_USER_LOGOUT";
export const ERROR_USER_LOGOUT = "ERROR_USER_LOGOUT";

export const REQUEST_LOGIN_KEEP_ALIVE = "REQUEST_LOGIN_KEEP_ALIVE";
export const RECEIVE_LOGIN_KEEP_ALIVE = "RECEIVE_LOGIN_KEEP_ALIVE";
export const ERROR_LOGIN_KEEP_ALIVE = "ERROR_LOGIN_KEEP_ALIVE";

export const CLEAR_USER_REDIRECT = "CLEAR_USER_REDIRECT";

export const REQUEST_SIDEBAR = "REQUEST_SIDEBAR";
export const RECEIVE_SIDEBAR = "RECEIVE_SIDEBAR";
export const ERROR_SIDEBAR = "ERROR_SIDEBAR";

export const TOGGLE_MENU_ITEM = "TOGGLE_MENU_ITEM";
export const TOGGLE_CASE_MENU_ITEM = "TOGGLE_CASE_MENU_ITEM";

export const ADD_TOAST = "ADD_TOAST";
export const REMOVE_TOAST = "REMOVE_TOAST";
export const ADD_TOAST_FROM_QUEUE = "ADD_TOAST_FROM_QUEUE";

export const REQUEST_SEARCH_RESULTS = "REQUEST_SEARCH_RESULTS";
export const REQUEST_SEARCH_RESULTS_LOCAL = "REQUEST_SEARCH_RESULTS_LOCAL";
export const RECEIVE_SEARCH_RESULTS = "RECEIVE_SEARCH_RESULTS";
export const ERROR_SEARCH_RESULTS = "ERROR_SEARCH_RESULTS";

export const REQUEST_POLICY_INFO_RESULTS = "REQUEST_POLICY_INFO_RESULTS";
export const RECEIVE_POLICY_INFO_RESULTS = "RECEIVE_POLICY_INFO_RESULTS";
export const ERROR_POLICY_INFO_RESULTS = "ERROR_POLICY_INFO_RESULTS";

export const REQUEST_CASE_INFO_RESULTS = "REQUEST_CASE_INFO_RESULTS";
export const RECEIVE_CASE_INFO_RESULTS = "RECEIVE_CASE_INFO_RESULTS";
export const ERROR_CASE_INFO_RESULTS = "ERROR_CASE_INFO_RESULTS";

export const REQUEST_CASE_NOTES_RESULTS = "REQUEST_CASE_NOTES_RESULTS";
export const RECEIVE_CASE_NOTES_RESULTS = "RECEIVE_CASE_NOTES_RESULTS";
export const ERROR_CASE_NOTES_RESULTS = "ERROR_CASE_NOTES_RESULTS";

export const REQUEST_CASE_HOLD_STATUS = "REQUEST_CASE_HOLD_STATUS";
export const RECEIVE_CASE_HOLD_STATUS = "RECEIVE_CASE_HOLD_STATUS";
export const ERROR_RETRIEVE_CASE_HOLD_STATUS = "ERROR_RETRIEVE_CASE_HOLD_STATUS";

export const REQUEST_IMPORT_MISMO = "REQUEST_IMPORT_MISMO";
export const RECEIVE_IMPORT_MISMO = "RECEIVE_IMPORT_MISMO";
export const ERROR_IMPORT_MISMO = "ERROR_IMPORT_MISMO";

// Broker actions
export const REQUEST_BROKERCASEHEADER = "REQUEST_BROKERCASEHEADER";
export const RECEIVE_BROKERCASEHEADER = "RECEIVE_BROKERCASEHEADER";
export const ERROR_BROKERCASEHEADER = "ERROR_BROKERCASEHEADER";

export const REQUEST_BROKERHISTORY = "REQUEST_BROKERHISTORY";
export const RECEIVE_BROKERHISTORY = "RECEIVE_BROKERHISTORY";
export const ERROR_BROKERHISTORY = "ERROR_BROKERHISTORY";

export const REQUEST_BROKERWAIVER_DECISION = "REQUEST_BROKERWAIVER_DECISION";
export const RECEIVE_BROKERWAIVER_DECISION = "RECEIVE_BROKERWAIVER_DECISION";
export const ERROR_BROKERWAIVER_DECISION = "ERROR_BROKERWAIVER_DECISION";

export const REQUEST_BROKERWAIVER_DECISION_POST =
  "REQUEST_BROKERWAIVER_DECISION_POST";
export const RECEIVE_BROKERWAIVER_DECISION_POST =
  "RECEIVE_BROKERWAIVER_DECISION_POST";
export const ERROR_BROKERWAIVER_DECISION_POST =
  "ERROR_BROKERWAIVER_DECISION_POST";

export const REQUEST_CASEHEADER_RESULTS = "REQUEST_CASEHEADER_RESULTS";
export const RECEIVE_CASEHEADER_RESULTS = "RECEIVE_CASEHEADER_RESULTS";
export const ERROR_CASEHEADER_RESULTS = "ERROR_CASEHEADER_RESULTS";

export const REQUEST_HISTORY_RESULTS = "REQUEST_HISTORY_RESULTS";
export const RECEIVE_HISTORY_RESULTS = "RECEIVE_HISTORY_RESULTS";
export const ERROR_HISTORY_RESULTS = "ERROR_HISTORY_RESULTS";

export const REQUEST_FILES_RESULTS = "REQUEST_FILES_RESULTS";
export const RECEIVE_FILES_RESULTS = "RECEIVE_FILES_RESULTS";
export const ERROR_FILES_RESULTS = "ERROR_FILES_RESULTS";

export const BEGIN_PHOTOS_SORT_ORDER = "BEGIN_PHOTOS_SORT_ORDER";
export const SET_PHOTOS_SORT_ORDER = "SET_PHOTOS_SORT_ORDER";
export const REQUEST_SAVE_PHOTOS_SORT_ORDER = "REQUEST_SAVE_PHOTOS_SORT_ORDER";
export const RECEIVE_SAVE_PHOTOS_SORT_ORDER = "RECEIVE_SAVE_PHOTOS_SORT_ORDER";
export const ERROR_SAVE_PHOTOS_SORT_ORDER = "ERROR_SAVE_PHOTOS_SORT_ORDER";

export const REQUEST_PRIVATENOTES_RESULTS = "REQUEST_PRIVATENOTES_RESULTS";
export const RECEIVE_PRIVATENOTES_RESULTS = "RECEIVE_PRIVATENOTES_RESULTS";
export const ERROR_PRIVATENOTES_RESULTS = "ERROR_PRIVATENOTES_RESULTS";
export const REQUEST_PRIVATENOTES_UPDATE = "REQUEST_PRIVATENOTES_UPDATE";
export const RECEIVE_PRIVATENOTES_UPDATE = "RECEIVE_PRIVATENOTES_UPDATE";
export const ERROR_PRIVATENOTES_UPDATE = "ERROR_PRIVATENOTES_UPDATE";

export const REQUEST_SPECIALATTENTIONNOTES_UPDATE =
  "REQUEST_SPECIALATTENTIONNOTES_UPDATE";
export const RECEIVE_SPECIALATTENTIONNOTES_UPDATE =
  "RECEIVE_SPECIALATTENTIONNOTES_UPDATE";
export const ERROR_SPECIALATTENTIONNOTES_UPDATE =
  "ERROR_SPECIALATTENTIONNOTES_UPDATE";

  export const REQUEST_AI_FORM_VERIFICATION_RESULTS = "REQUEST_AI_FORM_VERIFICATION_RESULTS";
  export const RECEIVE_AI_FORM_VERIFICATION_RESULTS = "RECEIVE_AI_FORM_VERIFICATION_RESULTS";
  export const ERROR_AI_FORM_VERIFICATION_RESULTS = "ERROR_AI_FORM_VERIFICATION_RESULTS";

  export const REQUEST_AI_FORM_VERIFICATION_FORM_RESULTS = "REQUEST_AI_FORM_VERIFICATION_FORM_RESULTS";
  export const RECEIVE_AI_FORM_VERIFICATION_FORM_RESULTS = "RECEIVE_AI_FORM_VERIFICATION_FORM_RESULTS";
  export const ERROR_AI_FORM_VERIFICATION_FORM_RESULTS = "ERROR_AI_FORM_VERIFICATION_FORM_RESULTS";

export const REQUEST_COMPARABLES_RESULTS = "REQUEST_COMPARABLES_RESULTS";
export const RECEIVE_COMPARABLES_RESULTS = "RECEIVE_COMPARABLES_RESULTS";
export const ERROR_COMPARABLES_RESULTS = "ERROR_COMPARABLES_RESULTS";

export const REQUEST_CASEPHOTOS_RESULTS = "REQUEST_CASEPHOTOS_RESULTS";
export const RECEIVE_CASEPHOTOS_RESULTS = "RECEIVE_CASEPHOTOS_RESULTS";
export const ERROR_CASEPHOTOS_RESULTS = "ERROR_CASEPHOTOS_RESULTS";

export const REQUEST_CASECOMPONENT_RESULTS = "REQUEST_CASECOMPONENT_RESULTS";
export const RECEIVE_CASECOMPONENT_RESULTS = "RECEIVE_CASECOMPONENT_RESULTS";
export const ERROR_CASECOMPONENT_RESULTS = "ERROR_CASECOMPONENT_RESULTS";

export const REQUEST_CASECOMPONENTS_RESULTS = "REQUEST_CASECOMPONENTS_RESULTS";
export const RECEIVE_CASECOMPONENTS_RESULTS = "RECEIVE_CASECOMPONENTS_RESULTS";
export const ERROR_CASECOMPONENTS_RESULTS = "ERROR_CASECOMPONENTS_RESULTS";

export const REQUEST_CASELIST_RESULTS = "REQUEST_CASELIST_RESULTS";
export const RECEIVE_CASELIST_RESULTS = "RECEIVE_CASELIST_RESULTS";
export const ERROR_CASELIST_RESULTS = "ERROR_CASELIST_RESULTS";

export const REQUEST_PROFILE_RESULTS = "REQUEST_PROFILE_RESULTS";
export const RECEIVE_PROFILE_RESULTS = "RECEIVE_PROFILE_RESULTS";
export const ERROR_PROFILE_RESULTS = "ERROR_PROFILE_RESULTS";

export const REQUEST_NOTIFICATIONS_RESULTS = "REQUEST_NOTIFICATIONS_RESULTS";
export const RECEIVE_NOTIFICATIONS_RESULTS = "RECEIVE_NOTIFICATIONS_RESULTS";
export const ERROR_NOTIFICATIONS_RESULTS = "ERROR_NOTIFICATIONS_RESULTS";

export const REQUEST_STATISTICS_RESULTS = "REQUEST_STATISTICS_RESULTS";
export const RECEIVE_STATISTICS_RESULTS = "RECEIVE_STATISTICS_RESULTS";
export const ERROR_STATISTICS_RESULTS = "ERROR_STATISTICS_RESULTS";

export const REQUEST_DASHBOARD_RESULTS = "REQUEST_DASHBOARD_RESULTS";
export const RECEIVE_DASHBOARD_RESULTS = "RECEIVE_DASHBOARD_RESULTS";
export const ERROR_DASHBOARD_RESULTS = "ERROR_DASHBOARD_RESULTS";

export const REQUEST_CASEFORMS_RESULTS = "REQUEST_CASEFORMS_RESULTS";
export const RECEIVE_CASEFORMS_RESULTS = "RECEIVE_CASEFORMS_RESULTS";
export const ERROR_CASEFORMS_RESULTS = "ERROR_CASEFORMS_RESULTS";

export const REQUEST_WORKFLOWMETHOD_RESULTS = "REQUEST_WORKFLOWMETHOD_RESULTS";
export const RECEIVE_WORKFLOWMETHOD_RESULTS = "RECEIVE_WORKFLOWMETHOD_RESULTS";
export const ERROR_WORKFLOWMETHOD_RESULTS = "ERROR_WORKFLOWMETHOD_RESULTS";

export const REQUEST_WORKFLOWSTATUS_RESULTS = "REQUEST_WORKFLOWSTATUS_RESULTS";
export const RECEIVE_WORKFLOWSTATUS_RESULTS = "RECEIVE_WORKFLOWSTATUS_RESULTS";
export const ERROR_WORKFLOWSTATUS_RESULTS = "ERROR_WORKFLOWSTATUS_RESULTS";

export const REQUEST_SKETCH_RESULTS = "REQUEST_SKETCH_RESULTS";
export const RECEIVE_SKETCH_RESULTS = "RECEIVE_SKETCH_RESULTS";
export const ERROR_SKETCH_RESULTS = "ERROR_SKETCH_RESULTS";

export const SUCCESS_PNX_SAVE = "SUCCESS_PNX_SAVE";
export const ERROR_PNX_SAVE = "ERROR_PNX_SAVE";

export const FORM_STATUS_CHANGE = "FORM_STATUS_CHANGE";

export const SWITCH_VIEW = "SWITCH_VIEW";

export const ALL_CARDS_EXPANDED = "ALL_CARDS_EXPANDED";

export const REQUEST_VALIDATE_FORMS = "REQUEST_VALIDATE_FORMS";
export const RECEIVE_VALIDATE_FORMS = "RECEIVE_VALIDATE_FORMS";
export const ERROR_VALIDATE_FORMS = "ERROR_VALIDATE_FORMS";

export const REQUEST_FORMISSUES_RESULTS = "REQUEST_FORMISSUES_RESULTS";
export const RECEIVE_FORMISSUES_RESULTS = "RECEIVE_FORMISSUES_RESULTS";
export const ERROR_FORMISSUES_RESULTS = "ERROR_FORMISSUES_RESULTS";

export const REQUEST_VALIDATIONISSUES_RESULTS =
  "REQUEST_VALIDATIONISSUES_RESULTS";
export const RECEIVE_VALIDATIONISSUES_RESULTS =
  "RECEIVE_VALIDATIONISSUES_RESULTS";
export const ERROR_VALIDATIONISSUES_RESULTS = "ERROR_VALIDATIONISSUES_RESULTS";
export const MARK_VALIDATIONISSUES_DIRTY = "MARK_VALIDATIONISSUES_DIRTY";

export const REQUEST_VALIDATIONSTATUS_RESULTS =
  "REQUEST_VALIDATIONSTATUS_RESULTS";
export const RECEIVE_VALIDATIONSTATUS_RESULTS =
  "RECEIVE_VALIDATIONSTATUS_RESULTS";
export const ERROR_VALIDATIONSTATUS_RESULTS = "ERROR_VALIDATIONSTATUS_RESULTS";

// export const REQUEST_VALIDATE_FORMS_SUBMIT = "REQUEST_VALIDATE_FORMS_SUBMIT";
// export const RECEIVE_VALIDATE_FORMS_SUBMIT = "RECEIVE_VALIDATE_FORMS_SUBMIT";
// export const ERROR_VALIDATE_FORMS_SUBMIT = "ERROR_VALIDATE_FORMS_SUBMIT";

export const REQUEST_VEROSPREVIEW_UPDATE = "REQUEST_VEROSPREVIEW_UPDATE";
export const RECEIVE_VEROSPREVIEW_UPDATE = "RECEIVE_VEROSPREVIEW_UPDATE";
export const ERROR_VEROSPREVIEW_UPDATE = "ERROR_VEROSPREVIEW_UPDATE";

export const REQUEST_VEROSSUBMIT_UPDATE = "REQUEST_VEROSSUBMIT_UPDATE";
export const RECEIVE_VEROSSUBMIT_UPDATE = "RECEIVE_VEROSSUBMIT_UPDATE";
export const ERROR_VEROSSUBMIT_UPDATE = "ERROR_VEROSSUBMIT_UPDATE";

export const VALIDATE_RESPONSE = "VALIDATE_RESPONSE";

export const CONTROLID_CHANGE = "CONTROLID_CHANGE";
export const CASEFILTER_CHANGE = "CASEFILTER_CHANGE";

export const REQUEST_APPRAISALQAREJECTIONS_RESULTS =
  "REQUEST_APPRAISALQAREJECTIONS_RESULTS";
export const RECEIVE_APPRAISALQAREJECTIONS_RESULTS =
  "RECEIVE_APPRAISALQAREJECTIONS_RESULTS";
export const ERROR_APPRAISALQAREJECTIONS_RESULTS =
  "ERROR_APPRAISALQAREJECTIONS_RESULTS";

export const REQUEST_APPRAISALQAREJECTION_UPDATE =
  "REQUEST_APPRAISALQAREJECTION_UPDATE";
export const RECEIVE_APPRAISALQAREJECTION_UPDATE =
  "RECEIVE_APPRAISALQAREJECTION_UPDATE";
export const ERROR_APPRAISALQAREJECTIONS_UPDATE =
  "ERROR_APPRAISALQAREJECTIONS_UPDATE";

export const REQUEST_CASETIMELOG_ADD = "REQUEST_CASETIMELOG_ADD";
export const RECEIVE_CASETIMELOG_ADD = "RECEIVE_CASETIMELOG_ADD";
export const ERROR_CASETIMELOG_ADD = "ERROR_CASETIMELOG_ADD";

export const REQUEST_WEBORDER_UPDATE = "REQUEST_WEBORDER_UPDATE";
export const RECEIVE_WEBORDER_UPDATE = "RECEIVE_WEBORDER_UPDATE";
export const ERROR_WEBORDER_UPDATE = "ERROR_WEBORDER_UPDATE";

export const REQUEST_LOCAL_TIME = "REQUEST_LOCAL_TIME";
export const RECEIVE_LOCAL_TIME = "RECEIVE_LOCAL_TIME";
export const ERROR_LOCAL_TIME = "ERROR_LOCAL_TIME";

export const REQUEST_CASETIMELOG_UPDATE = "REQUEST_CASETIMELOG_UPDATE";
export const RECEIVE_CASETIMELOG_UPDATE = "RECEIVE_CASETIMELOG_UPDATE";
export const ERROR_CASETIMELOG_UPDATE = "ERROR_CASETIMELOG_UPDATE";

export const REQUEST_CASETIMELOG_DELETE = "REQUEST_CASETIMELOG_DELETE";
export const RECEIVE_CASETIMELOG_DELETE = "RECEIVE_CASETIMELOG_DELETE";
export const ERROR_CASETIMELOG_DELETE = "ERROR_CASETIMELOG_DELETE";

export const REQUEST_CASETIMELOG_BYCASE = "REQUEST_CASETIMELOG_BYCASE";
export const RECEIVE_CASETIMELOG_BYCASE = "RECEIVE_CASETIMELOG_BYCASE";
export const ERROR_CASETIMELOG_BYCASE = "ERROR_CASETIMELOG_BYCASE";

export const REQUEST_CASETIMELOG_PAYPERIOD = "REQUEST_CASETIMELOG_PAYPERIOD";
export const RECEIVE_CASETIMELOG_PAYPERIOD = "RECEIVE_CASETIMELOG_PAYPERIOD";
export const ERROR_CASETIMELOG_PAYPERIOD = "ERROR_CASETIMELOG_PAYPERIOD";

export const REQUEST_PAYPERIOD_GETLIST = "REQUEST_PAYPERIOD_GETLIST";
export const RECEIVE_PAYPERIOD_GETLIST = "RECEIVE_PAYPERIOD_GETLIST";
export const ERROR_PAYPERIOD_GETLIST = "ERROR_PAYPERIOD_GETLIST";

export const REQUEST_PAYPERIOD_USERS = "REQUEST_PAYPERIOD_USERS";
export const RECEIVE_PAYPERIOD_USERS = "RECEIVE_PAYPERIOD_USERS";
export const ERROR_PAYPERIOD_USERS = "ERROR_PAYPERIOD_USERS";

export const REQUEST_CASETIMELOG_PAIDLIST = "REQUEST_CASETIMELOG_PAIDLIST";
export const RECEIVE_CASETIMELOG_PAIDLIST = "RECEIVE_CASETIMELOG_PAIDLIST";
export const ERROR_CASETIMELOG_PAIDLIST = "ERROR_CASETIMELOG_PAIDLIST";

export const REQUEST_CASETIMELOG_APPROVE = "REQUEST_CASETIMELOG_APPROVE";
export const RECEIVE_CASETIMELOG_APPROVE = "RECEIVE_CASETIMELOG_APPROVE";
export const ERROR_CASETIMELOG_APPROVE = "ERROR_CASETIMELOG_APPROVE";

export const REQUEST_PAYPERIOD_APPROVED_GETLIST =
  "REQUEST_PAYPERIOD_APPROVED_GETLIST";
export const RECEIVE_PAYPERIOD_APPROVED_GETLIST =
  "RECEIVE_PAYPERIOD_APPROVED_GETLIST";
export const ERROR_PAYPERIOD_APPROVED_GETLIST =
  "ERROR_PAYPERIOD_APPROVED_GETLIST";

export const REQUEST_AGENT_SEARCHTERM = "REQUEST_AGENT_SEARCHTERM";
export const RECEIVE_AGENT_SEARCHTERM = "RECEIVE_AGENT_SEARCHTERM";
export const ERROR_AGENT_SEARCHTERM = "ERROR_AGENT_SEARCHTERM";

export const REQUEST_AGENT_CREATE = "REQUEST_AGENT_CREATE";
export const RECEIVE_AGENT_CREATE = "RECEIVE_AGENT_CREATE";
export const ERROR_AGENT_CREATE = "ERROR_AGENT_CREATE";

export const REQUEST_AGENT_RETRIEVE = "REQUEST_AGENT_RETRIEVE";
export const RECEIVE_AGENT_RETRIEVE = "RECEIVE_AGENT_RETRIEVE";
export const ERROR_AGENT_RETRIEVE = "ERROR_AGENT_RETRIEVE";

export const REQUEST_AGENT_UPDATE = "REQUEST_AGENT_UPDATE";
export const RECEIVE_AGENT_UPDATE = "RECEIVE_AGENT_UPDATE";
export const ERROR_AGENT_UPDATE = "ERROR_AGENT_UPDATE";

export const REQUEST_CUSTOMER_MAJORCOMPANIES = "REQUEST_CUSTOMER_MAJORCOMPANIES";
export const RECEIVE_CUSTOMER_MAJORCOMPANIES = "RECEIVE_CUSTOMER_MAJORCOMPANIES";
export const ERROR_CUSTOMER_MAJORCOMPANIES = "ERROR_CUSTOMER_MAJORCOMPANIES";

export const REQUEST_UNDERWRITERSEARCH_MAJORCOMPANYCODE = "REQUEST_UNDERWRITERSEARCH_MAJORCOMPANYCODE";
export const RECEIVE_UNDERWRITERSEARCH_MAJORCOMPANYCODE = "RECEIVE_UNDERWRITERSEARCH_MAJORCOMPANYCODE";
export const ERROR_UNDERWRITERSEARCH_MAJORCOMPANYCODE = "ERROR_UNDERWRITERSEARCH_MAJORCOMPANYCODE";

export const REQUEST_BROKER_LENDERS = "REQUEST_BROKER_LENDERS";
export const RECEIVE_BROKER_LENDERS = "RECEIVE_BROKER_LENDERS";
export const ERROR_BROKER_LENDERS = "ERROR_BROKER_LENDERS";

export const REQUEST_BROKER_REPORT_TYPES = "REQUEST_BROKER_REPORT_TYPES";
export const RECEIVE_BROKER_REPORT_TYPES = "RECEIVE_BROKER_REPORT_TYPES";
export const ERROR_BROKER_REPORT_TYPES = "ERROR_BROKER_REPORT_TYPES";

export const REQUEST_APPOINTMENT_HOLIDAYS = "REQUEST_APPOINTMENT_HOLIDAYS";
export const RECEIVE_APPOINTMENT_HOLIDAYS = "RECEIVE_APPOINTMENT_HOLIDAYS";
export const ERROR_APPOINTMENT_HOLIDAYS = "ERROR_APPOINTMENT_HOLIDAYS";

export const RESET_WEB_ORDER = "RESET_WEB_ORDER";
export const UPDATE_WORKFLOW_MONITOR = "UPDATE_WORKFLOW_MONITOR";

export const REQUEST_CHANGESTATUS_RESULTS = "REQUEST_CHANGESTATUS_RESULTS";
export const RECEIVE_CHANGESTATUS_RESULTS = "RECEIVE_CHANGESTATUS_RESULTS";
export const ERROR_CHANGESTATUS_RESULTS = "ERROR_CHANGESTATUS_RESULTS";

export const REQUEST_GRID_FILTERS_RESULTS = "REQUEST_GRID_FILTERS_IRESULTS";
export const RECEIVE_GRID_FILTERS_RESULTS = "RECEIVE_GRID_FILTERS_RESULTS";
export const ERROR_GRID_FILTERS_RESULTS = "ERROR_GRID_FILTERS_RESULTS";

export const REQUEST_ASSIGNMENT_CONFIG = "REQUEST_ASSIGNMENT_CONFIG";
export const RECEIVE_ASSIGNMENT_CONFIG = "RECEIVE_ASSIGNMENT_CONFIG";
export const ERROR_ASSIGNMENT_CONFIG = "ERROR_ASSIGNMENT_CONFIG";

export const REQUEST_CASE_LOCATIONS = "REQUEST_CASE_LOCATIONS";
export const RECEIVE_CASE_LOCATIONS = "RECEIVE_CASE_LOCATIONS";
export const ERROR_CASE_LOCATIONS = "ERROR_CASE_LOCATIONS";

export const REQUEST_INSPECTOR_LOCATIONS = "REQUEST_INSPECTOR_LOCATIONS";
export const RECEIVE_INSPECTOR_LOCATIONS = "RECEIVE_INSPECTOR_LOCATIONS";
export const ERROR_INSPECTOR_LOCATIONS = "ERROR_INSPECTOR_LOCATIONS";

export const REQUEST_ZIP_CODES = "REQUEST_ZIP_CODES";
export const RECEIVE_ZIP_CODES = "RECEIVE_ZIP_CODES";
export const ERROR_ZIP_CODES = "ERROR_ZIP_CODES";

export const REQUEST_CASE_DETAILS = "REQUEST_CASE_DETAILS";
export const RECEIVE_CASE_DETAILS = "RECEIVE_CASE_DETAILS";
export const ERROR_CASE_DETAILS = "ERROR_CASE_DETAILS";

export const REQUEST_ASSIGNED_CASES = "REQUEST_ASSIGNED_CASES";
export const RECEIVE_ASSIGNED_CASES = "RECEIVE_ASSIGNED_CASES";
export const ERROR_ASSIGNED_CASES = "ERROR_ASSIGNED_CASES";

export const REQUEST_ASSIGNED_CASES_WITH_APPTS = "REQUEST_ASSIGNED_CASES_WITH_APPTS";
export const RECEIVE_ASSIGNED_CASES_WITH_APPTS = "RECEIVE_ASSIGNED_CASES_WITH_APPTS";
export const ERROR_ASSIGNED_CASES_WITH_APPTS = "ERROR_ASSIGNED_CASES_WITH_APPTS";
export const UPDATE_ASSIGNED_CASES_WITH_APPTS_PINS = "UPDATE_ASSIGNED_CASES_WITH_APPTS_PINS";

export const PIN_NAME_SELECTED_FR_APPTS = "Selected FR Assigned Appts";
export const PIN_NAME_OTHER_FR_APPTS = "Other FRs Assigned Appts";

export const REMOVE_CASE_FROM_CASE_DETAILS = "REMOVE_CASE_FROM_CASE_DETAILS";
export const CLEAR_MAP_SELECTION = "CLEAR_MAP_SELECTION";
export const CLEAR_INSPECTOR_DETAILS = "CLEAR_INSPECTOR_DETAILS";
export const REMOVE_CASES_FROM_MAP = "REMOVE_CASES_FROM_MAP";
export const CLEAR_CASE_DETAILS = "CLEAR_CASE_DETAILS";

export const REQUEST_INSPECTOR_DETAILS = "REQUEST_INSPECTOR_DETAILS";
export const RECEIVE_INSPECTOR_DETAILS = "RECEIVE_INSPECTOR_DETAILS";
export const ERROR_INSPECTOR_DETAILS = "ERROR_INSPECTOR_DETAILS";

export const REQUEST_GRID_FILTERS_INSURANCE_RESULTS =
  "REQUEST_GRID_FILTERS_INSURANCE_RESULTS";
export const RECEIVE_GRID_FILTERS_INSURANCE_RESULTS =
  "RECEIVE_GRID_FILTERS_INSURANCE_RESULTS";
export const ERROR_GRID_FILTERS_INSURANCE_RESULTS =
  "ERROR_GRID_FILTERS_INSURANCE_RESULTS";

export const REQUEST_GRID_FILTER_MENUS_RESULTS =
  "REQUEST_GRID_FILTER_MENUS_RESULTS";
export const RECEIVE_GRID_FILTER_MENUS_RESULTS =
  "RECEIVE_GRID_FILTER_MENUS_RESULTS";
export const ERROR_GRID_FILTER_MENUS_RESULTS =
  "ERROR_GRID_FILTER_MENUS_RESULTS";

export const REQUEST_CHECKOUT_GET = "REQUEST_CHECKOUT_GET";
export const RECEIVE_CHECKOUT_GET = "RECEIVE_CHECKOUT_GET";
export const ERROR_CHECKOUT_GET = "ERROR_CHECKOUT_GET";

export const REQUEST_CHECKOUT_SAVE = "REQUEST_CHECKOUT_SAVE";
export const RECEIVE_CHECKOUT_SAVE = "RECEIVE_CHECKOUT_SAVE";
export const ERROR_CHECKOUT_SAVE = "ERROR_CHECKOUT_SAVE";

export const REQUEST_CHECKOUT_CANCEL = "REQUEST_CHECKOUT_CANCEL";
export const RECEIVE_CHECKOUT_CANCEL = "RECEIVE_CHECKOUT_CANCEL";
export const ERROR_CHECKOUT_CANCEL = "ERROR_CHECKOUT_CANCEL";

export const REQUEST_STATES_LIST = "REQUEST_STATES_LIST";
export const RECEIVE_STATES_LIST = "RECEIVE_STATES_LIST";
export const ERROR_STATES_LIST = "ERROR_STATES_LIST";

export const REQUEST_COUNTIES_BY_STATE = "REQUEST_COUNTIES_BY_STATE";
export const RECEIVE_COUNTIES_BY_STATE = "RECEIVE_COUNTIES_BY_STATE";
export const ERROR_COUNTIES_BY_STATE = "ERROR_COUNTIES_BY_STATE";

export const REQUEST_ALL_COUNTIES = "REQUEST_ALL_COUNTIES";
export const RECEIVE_ALL_COUNTIES = "RECEIVE_ALL_COUNTIES";
export const ERROR_ALL_COUNTIES = "ERROR_ALL_COUNTIES";

export const REQUEST_ALL_SERVICE_REGIONS = "REQUEST_ALL_SERVICE_REGIONS";
export const RECEIVE_ALL_SERVICE_REGIONS = "RECEIVE_ALL_SERVICE_REGIONS";
export const ERROR_ALL_SERVICE_REGIONS = "ERROR_ALL_SERVICE_REGIONS";

export const REQUEST_ASSIGN_STATES_MANAGER = "REQUEST_ASSIGN_STATES_MANAGER";
export const RECEIVE_ASSIGN_STATES_MANAGER = "RECEIVE_ASSIGN_STATES_MANAGER";
export const ERROR_ASSIGN_STATES_MANAGER = "ERROR_ASSIGN_STATES_MANAGER";

export const REQUEST_ASSIGN_COUNTIES_MANAGER = "REQUEST_ASSIGN_COUNTIES_MANAGER";
export const RECEIVE_ASSIGN_COUNTIES_MANAGER = "RECEIVE_ASSIGN_COUNTIES_MANAGER";
export const ERROR_ASSIGN_COUNTIES_MANAGER = "ERROR_ASSIGN_COUNTIES_MANAGER";

export const REQUEST_SAVE_PREFERENCE = "REQUEST_SAVE_PREFERENCE";
export const RECEIVE_SAVE_PREFERENCE = "RECEIVE_SAVE_PREFERENCE";
export const ERROR_SAVE_PREFERENCE = "ERROR_SAVE_PREFERENCE";

export const REQUEST_LOAD_PREFERENCE = "REQUEST_LOAD_PREFERENCE";
export const RECEIVE_LOAD_PREFERENCE = "RECEIVE_LOAD_PREFERENCE";
export const ERROR_LOAD_PREFERENCE = "ERROR_LOAD_PREFERENCE";

export const REQUEST_LOAD_PREFERENCES = "REQUEST_LOAD_PREFERENCES";
export const RECEIVE_LOAD_PREFERENCES = "RECEIVE_LOAD_PREFERENCES";
export const ERROR_LOAD_PREFERENCES = "ERROR_LOAD_PREFERENCES";

export const RESIZE_REQUIRED = "RESIZE_REQUIRED";
export const RESIZE_COMPLETE = "RESIZE_COMPLETE";

export const REQUEST_ASSIGN_CASE = "REQUEST_ASSIGN_CASE";
export const RECEIVE_ASSIGN_CASE = "RECEIVE_ASSIGN_CASE";
export const ERROR_ASSIGN_CASE = "ERROR_ASSIGN_CASE";

export const REQUEST_UNASSIGN_CASE = "REQUEST_UNASSIGN_CASE";
export const RECEIVE_UNASSIGN_CASE = "RECEIVE_UNASSIGN_CASE";
export const ERROR_UNASSIGN_CASE = "ERROR_UNASSIGN_CASE";

export const SAVE_CLIENT_SIDE_FILTERS = "SAVE_CLIENT_SIDE_FILTERS";

export const REQUEST_PAY_SUMMARY = "REQUEST_PAY_SUMMARY";
export const RECEIVE_PAY_SUMMARY = "RECEIVE_PAY_SUMMARY";
export const ERROR_PAY_SUMMARY = "ERROR_PAY_SUMMARY";

export const REQUEST_COMPARABLEDETAILS = "REQUEST_COMPARABLEDETAILS";
export const RECEIVE_COMPARABLEDETAILS = "RECEIVE_COMPARABLEDETAILS";
export const ERROR_COMPARABLEDETAILS = "ERROR_COMPARABLEDETAILS";

export const REQUEST_GRIDDATA = "REQUEST_GRIDDATA";
export const RECEIVE_GRIDDATA = "RECEIVE_GRIDDATA";
export const ERROR_GRIDDATA = "ERROR_GRIDDATA";

export const REQUEST_GRIDDATA_POST = "REQUEST_GRIDDATA_POST";
export const RECEIVE_GRIDDATA_POST = "RECEIVE_GRIDDATA_POST";
export const ERROR_GRIDDATA_POST = "ERROR_GRIDDATA_POST";

export const REQUEST_FR_LIST = "REQUEST_FR_LIST";
export const RECEIVE_FR_LIST = "RECEIVE_FR_LIST";
export const ERROR_FR_LIST = "ERROR_FR_LIST";

export const REQUEST_FR_PAY_SUMMARY = "REQUEST_FR_PAY_SUMMARY";
export const RECEIVE_FR_PAY_SUMMARY = "RECEIVE_FR_PAY_SUMMARY";
export const ERROR_FR_PAY_SUMMARY = "ERROR_FR_PAY_SUMMARY";

export const REQUEST_MAINTENANCE_CARDS = "REQUEST_MAINTENANCE_CARDS";
export const RECEIVE_MAINTENANCE_CARDS = "RECEIVE_MAINTENANCE_CARDS";
export const ERROR_MAINTENANCE_CARDS = "ERROR_MAINTENANCE_CARDS";

export const REQUEST_INTERNET_USER_LIST = "REQUEST_INTERNET_USER_LIST";
export const RECEIVE_INTERNET_USER_LIST = "RECEIVE_INTERNET_USER_LIST";
export const ERROR_INTERNET_USER_LIST = "ERROR_INTERNET_USER_LIST";

export const REQUEST_QA_CASE = "REQUEST_QA_CASE";
export const RECEIVE_QA_CASE = "RECEIVE_QA_CASE";
export const ERROR_QA_CASE = "ERROR_QA_CASE";

export const REQUEST_QA_CASE_RETURN = "REQUEST_QA_CASE_RETURN";
export const RECEIVE_QA_CASE_RETURN = "RECEIVE_QA_CASE_RETURN";
export const ERROR_QA_CASE_RETURN = "ERROR_QA_CASE_RETURN";

export const REQUEST_QA_CASE_SEND = "REQUEST_QA_CASE_SEND";
export const RECEIVE_QA_CASE_SEND = "RECEIVE_QA_CASE_SEND";
export const ERROR_QA_CASE_SEND = "ERROR_QA_CASE_SEND";

export const REQUEST_QA_CASE_COMPLETE = "REQUEST_QA_CASE_COMPLETE";
export const RECEIVE_QA_CASE_COMPLETE = "RECEIVE_QA_CASE_COMPLETE";
export const ERROR_QA_CASE_COMPLETE = "ERROR_QA_CASE_COMPLETE";

export const REQUEST_PROPMIXSSO = "REQUEST_PROPMIXSSO";
export const RECEIVE_PROPMIXSSO = "RECEIVE_PROPMIXSSO";
export const ERROR_PROPMIXSSO = "ERROR_PROPMIXSSO";

export const REQUEST_LOGIN_STATISTICS = "REQUEST_LOGIN_STATISTICS";
export const RECEIVE_LOGIN_STATISTICS = "RECEIVE_LOGIN_STATISTICS";
export const ERROR_LOGIN_STATISTICS = "ERROR_LOGIN_STATISTICS";

export const REQUEST_USER_INFO = "REQUEST_USER_INFO";
export const RECEIVE_USER_INFO = "RECEIVE_USER_INFO";
export const ERROR_USER_INFO = "ERROR_USER_INFO";

export const REQUEST_SEND_PASSWORDLINK = "REQUEST_SEND_PASSWORDLINK";
export const RECEIVE_SEND_PASSWORDLINK = "RECEIVE_SEND_PASSWORDLINK";
export const ERROR_SEND_PASSWORDLINK = "ERROR_SEND_PASSWORDLINK";

export const CLEAR_INTERNET_USER = "CLEAR_INTERNET_USER";

export const REQUEST_ALL_CUSTOMERS = "REQUEST_ALL_CUSTOMERS";
export const RECEIVE_ALL_CUSTOMERS = "RECEIVE_ALL_CUSTOMERS";
export const ERROR_ALL_CUSTOMERS = "ERROR_ALL_CUSTOMERS";
export const REQUEST_ALL_SURVEYTYPES = "REQUEST_ALL_SURVEYTYPES";
export const RECEIVE_ALL_SURVEYTYPES = "RECEIVE_ALL_SURVEYTYPES";
export const ERROR_ALL_SURVEYTYPES = "ERROR_ALL_SURVEYTYPES";

export const REQUEST_ADD_COMPANY = "REQUEST_ADD_COMPANY";
export const RECEIVE_ADD_COMPANY = "RECEIVE_ADD_COMPANY";
export const ERROR_ADD_COMPANY = "ERROR_ADD_COMPANY";

export const REQUEST_DELETE_COMPANY = "REQUEST_DELETE_COMPANY";
export const RECEIVE_DELETE_COMPANY = "RECEIVE_DELETE_COMPANY";
export const ERROR_DELETE_COMPANY = "ERROR_DELETE_COMPANY";

export const REQUEST_GET_UNDERWRITERS = "REQUEST_GET_UNDERWRITERS";
export const RECEIVE_GET_UNDERWRITERS = "RECEIVE_GET_UNDERWRITERS";
export const ERROR_GET_UNDERWRITERS = "ERROR_GET_UNDERWRITERS";

export const REQUEST_GET_AUTHORIZED_UNDERWRITERS = "REQUEST_GET_AUTHORIZED_UNDERWRITERS";
export const RECEIVE_GET_AUTHORIZED_UNDERWRITERS = "RECEIVE_GET_AUTHORIZED_UNDERWRITERS";
export const ERROR_GET_AUTHORIZED_UNDERWRITERS = "ERROR_GET_AUTHORIZED_UNDERWRITERS";

export const REQUEST_ADD_INTERNET_USER = "REQUEST_ADD_INTERNET_USER";
export const RECEIVE_ADD_INTERNET_USER = "RECEIVE_ADD_INTERNET_USER";
export const ERROR_ADD__INTERNET_USER = "ERROR_ADD__INTERNET_USER";

export const REQUEST_REMOVE_INTERNET_USER = "REQUEST_REMOVE_INTERNET_USER";
export const RECEIVE_REMOVE_INTERNET_USER = "RECEIVE_REMOVE_INTERNET_USER";
export const ERROR_REMOVE_INTERNET_USER = "ERROR_REMOVE_INTERNET_USER";

export const REQUEST_ADD_AGENCY = "REQUEST_ADD_AGENCY";
export const RECEIVE_ADD_AGENCY = "RECEIVE_ADD_AGENCY";
export const ERROR_ADD_AGENCY = "ERROR_ADD_AGENCY";

export const REQUEST_DELETE_AGENCY = "REQUEST_DELETE_AGENCY";
export const RECEIVE_DELETE_AGENCY = "RECEIVE_DELETE_AGENCY";
export const ERROR_DELETE_AGENCY = "ERROR_DELETE_AGENCY";

export const REQUEST_ALL_RIGHTS = "REQUEST_ALL_RIGHTS";
export const RECEIVE_ALL_RIGHTS = "RECEIVE_ALL_RIGHTS";
export const ERROR_ALL_RIGHTS = "ERROR_ALL_RIGHTS";

export const REQUEST_ADD_RIGHT = "REQUEST_ADD_RIGHT";
export const RECEIVE_ADD_RIGHT = "RECEIVE_ADD_RIGHT";
export const ERROR_ADD_RIGHT = "ERROR_ADD_RIGHT";

export const REQUEST_DELETE_RIGHT = "REQUEST_DELETE_RIGHT";
export const RECEIVE_DELETE_RIGHT = "RECEIVE_DELETE_RIGHT";
export const ERROR_DELETE_RIGHT = "ERROR_DELETE_RIGHT";

export const REQUEST_ALL_ROLES = "REQUEST_ALL_ROLES";
export const RECEIVE_ALL_ROLES = "RECEIVE_ALL_ROLES";
export const ERROR_ALL_ROLES = "ERROR_ALL_ROLES";

export const REQUEST_ALL_MAJOR_COMPANIES = "REQUEST_ALL_MAJOR_COMPANIES";
export const RECEIVE_ALL_MAJOR_COMPANIES = "RECEIVE_ALL_MAJOR_COMPANIES";
export const ERROR_ALL_MAJOR_COMPANIES = "ERROR_ALL_MAJOR_COMPANIES";

export const REQUEST_UPDATE_USER = "REQUEST_UPDATE_USER";
export const RECEIVE_UPDATE_USER = "RECEIVE_UPDATE_USER";
export const ERROR_UPDATE_USER = "ERROR_UPDATE_USER";

export const REQUEST_GET_ROLERIGHTS = "REQUEST_GET_ROLERIGHTS";
export const SUCCESS_GET_ROLERIGHTS = "SUCCESS_GET_ROLERIGHTS";
export const ERROR_GET_ROLERIGHTS = "ERROR_GET_ROLERIGHTS";

export const REQUEST_EDIT_ROLERIGHTS = "REQUEST_EDIT_ROLERIGHTS";
export const SUCCESS_EDIT_ROLERIGHTS = "SUCCESS_EDIT_ROLERIGHTS";
export const ERROR_EDIT_ROLERIGHTS = "ERROR_EDIT_ROLERIGHTS";

export const REQEUST_UPDATE_FIELD_REP = "REQEUST_UPDATE_FIELD_REP";
export const RECEIVE_UPDATE_FIELD_REP = "RECEIVE_UPDATE_FIELD_REP";
export const ERROR_UPDATE_FIELD_REP = "ERROR_UPDATE_FIELD_REP";

export const REQUEST_CLOCK_IN = "REQUEST_CLOCK_IN";
export const RECEIVE_CLOCK_IN = "RECEIVE_CLOCK_IN";
export const ERROR_CLOCK_IN = "ERROR_CLOCK_IN";

export const REQUEST_CLOCK_OUT = "REQUEST_CLOCK_OUT";
export const RECEIVE_CLOCK_OUT = "RECEIVE_CLOCK_OUT";
export const ERROR_CLOCK_OUT = "ERROR_CLOCK_OUT";

export const REQUEST_CURRENT_CLOCK = "REQUEST_CURRENT_CLOCK";
export const RECEIVE_CURRENT_CLOCK = "RECEIVE_CURRENT_CLOCK";
export const ERROR_CURRENT_CLOCK = "ERROR_CURRENT_CLOCK";

export const REQUEST_QA_SKETCH = "REQUEST_QA_SKETCH";
export const RECEIVE_QA_SKETCH = "RECEIVE_QA_SKETCH";
export const ERROR_QA_SKETCH = "ERROR_QA_SKETCH";

export const REQUEST_QA_RCT = "REQUEST_QA_RCT";
export const RECEIVE_QA_RCT = "RECEIVE_QA_RCT";
export const ERROR_QA_RCT = "ERROR_QA_RCT";

export const REQUEST_QA_PAY_PERIOD = "REQUEST_QA_PAY_PERIOD";
export const RECEIVE_QA_PAY_PERIOD = "RECEIVE_QA_PAY_PERIOD";
export const ERROR_QA_PAY_PERIOD = "ERROR_QA_PAY_PERIOD";

export const REQUEST_QUICKLISTS = "REQUEST_QUICKLISTS";
export const RECEIVE_QUICKLISTS = "RECEIVE_QUICKLISTS";
export const ERROR_QUICKLISTS = "ERROR_QUICKLISTS";

export const REQUEST_QUICKLISTTEMPLATES = "REQUEST_QUICKLISTTEMPLATES";
export const RECEIVE_QUICKLISTTEMPLATES = "RECEIVE_QUICKLISTTEMPLATES";
export const ERROR_QUICKLISTTEMPLATES = "ERROR_QUICKLISTTEMPLATES";

export const REQUEST_QUICKLISTCOUNT = "REQUEST_QUICKLISTCOUNT";
export const RECEIVE_QUICKLISTCOUNT = "RECEIVE_QUICKLISTCOUNT";
export const ERROR_QUICKLISTCOUNT = "ERROR_QUICKLISTCOUNT";

export const REQUEST_QUICKLISTRESULT = "REQUEST_QUICKLISTRESULT";
export const RECEIVE_QUICKLISTRESULT = "RECEIVE_QUICKLISTRESULT";
export const ERROR_QUICKLISTRESULT = "ERROR_QUICKLISTRESULT";

export const REQUEST_TIMECLOCK_PAYPERIOD = "REQUEST_TIMECLOCK_PAYPERIOD";
export const RECEIVE_TIMECLOCK_PAYPERIOD = "RECEIVE_TIMECLOCK_PAYPERIOD";
export const ERROR_TIMECLOCK_PAYPERIOD = "ERROR_TIMECLOCK_PAYPERIOD";

export const REQUEST_TIMELOGBYDAY_SUMMARY = "REQUEST_TIMELOGBYDAY_SUMMARY";
export const RECEIVE_TIMELOGBYDAY_SUMMARY = "RECEIVE_TIMELOGBYDAY_SUMMARY";
export const ERROR_TIMELOGBYDAY_SUMMARY = "ERROR_TIMELOGBYDAY_SUMMARY";

export const REQUEST_ADD_TIMECLOCK = "REQUEST_ADD_TIMECLOCK";
export const RECEIVE_ADD_TIMECLOCK = "RECEIVE_ADD_TIMECLOCK";
export const ERROR_ADD_TIMECLOCK = "ERROR_ADD_TIMECLOCK";

export const REQUEST_DELETE_TIMECLOCK = "REQUEST_DELETE_TIMECLOCK";
export const RECEIVE_DELETE_TIMECLOCK = "RECEIVE_DELETE_TIMECLOCK";
export const ERROR_DELETE_TIMECLOCK = "ERROR_DELETE_TIMECLOCK";

export const REQUEST_UPDATE_TIMECLOCK = "REQUEST_UPDATE_TIMECLOCK";
export const RECEIVE_UPDATE_TIMECLOCK = "RECEIVE_UPDATE_TIMECLOCK";
export const ERROR_UPDATE_TIMECLOCK = "ERROR_UPDATE_TIMECLOCK";

export const REQUEST_EMPLOYEES_BY_PAYPERIOD = "REQUEST_EMPLOYEES_BY_PAYPERIOD";
export const RECEIVE_EMPLOYEES_BY_PAYPERIOD = "RECEIVE_EMPLOYEES_BY_PAYPERIOD";
export const CLEAR_EMPLOYEES_BY_PAYPERIOD = "CLEAR_EMPLOYEES_BY_PAYPERIOD";
export const ERROR_EMPLOYEES_BY_PAYPERIOD = "ERROR_EMPLOYEES_BY_PAYPERIOD";

export const REQUEST_APPROVE_USER_PAYPERIOD = "REQUEST_APPROVE_USER_PAYPERIOD";
export const RECEIVE_APPROVE_USER_PAYPERIOD = "RECEIVE_APPROVE_USER_PAYPERIOD";
export const ERROR_APPROVE_USER_PAYPERIOD = "ERROR_APPROVE_USER_PAYPERIOD";

export const SET_QA_READY = "SET_QA_READY";
export const SET_QA_STARTED = "SET_QA_STARTED";
export const SET_QA_PAUSED = "SET_QA_PAUSED";
export const SET_QA_VALIDATION_ERRORS = "SET_QA_VALIDATION_ERRORS";
export const SET_QA_SUMMARYVIEW_ENABLED = "SET_QA_SUMMARYVIEW_ENABLED";
export const SET_QA_SHOW_REJECT_DIALOG = "SET_QA_SHOW_REJECT_DIALOG";
export const SET_QA_SWITCH_CASE_DIALOG = "SET_QA_SWITCH_CASE_DIALOG";
export const SET_QA_SHOW_SEND_MANAGER_DIALOG = "SET_QA_SHOW_SEND_MANAGER_DIALOG";
export const SET_QA_SHOW_COMPLETED_CASE_DIALOG = "SET_QA_SHOW_COMPLETED_CASE_DIALOG";
export const SET_QA_COMPLETING_CASE = "SET_QA_COMPLETING_CASE";
export const SET_QA_REJECTING_CASE = "SET_QA_REJECTING_CASE";
export const SET_QA_ESCALATING_CASE = "SET_QA_ESCALATING_CASE";
export const SET_QA_KEEP_GETTING_CASES = "SET_QA_KEEP_GETTING_CASES";
export const SET_QA_VIEW_SAVE_DATA = "SET_QA_VIEW_SAVE_DATA";
export const RESET_QA_STATE = "RESET_QA_STATE";
export const SET_QA_TIMESPENT = "SET_QA_TIMESPENT";

export const REQUEST_QUICKLISTSAVE = "REQUEST_QUICKLISTSAVE";
export const RECEIVE_QUICKLISTSAVE = "RECEIVE_QUICKLISTSAVE";
export const ERROR_QUICKLISTSAVE = "ERROR_QUICKLISTSAVE";

export const REQUEST_QUICKLISTDELETE = "REQUEST_QUICKLISTDELETE";
export const RECEIVE_QUICKLISTDELETE = "RECEIVE_QUICKLISTDELETE";
export const ERROR_QUICKLISTDELETE = "ERROR_QUICKLISTDELETE";

export const REQUEST_QA_MANAGERS = "REQUEST_QA_MANAGERS";
export const RECEIVE_QA_MANAGERS = "RECEIVE_QA_MANAGERS";
export const ERROR_QA_MANAGERS = "ERROR_QA_MANAGERS";

export const REQUEST_EMPLOYEE_DETAILS = "REQUEST_EMPLOYEE_DETAILS";
export const RECEIVE_EMPLOYEE_DETAILS = "RECEIVE_EMPLOYEE_DETAILS";
export const ERROR_EMPLOYEE_DETAILS = "ERROR_EMPLOYEE_DETAILS";

export const REQUEST_EMPLOYEE_LIST = "REQUEST_EMPLOYEE_LIST";
export const RECEIVE_EMPLOYEE_LIST = "RECEIVE_EMPLOYEE_LIST";
export const ERROR_EMPLOYEE_LIST = "ERROR_EMPLOYEE_LIST";

export const REQUEST_QUICKLISTGROUP = "REQUEST_QUICKLISTGROUP";
export const RECEIVE_QUICKLISTGROUP = "RECEIVE_QUICKLISTGROUP";
export const ERROR_QUICKLISTGROUP = "ERROR_QUICKLISTGROUP";

export const REQUEST_APPRAISER_COUNTIES = "REQUEST_APPRAISER_COUNTIES";
export const RECEIVE_APPRAISER_COUNTIES = "RECEIVE_APPRAISER_COUNTIES";
export const ERROR_APPRAISER_COUNTIES = "ERROR_APPRAISER_COUNTIES";

export const REQUEST_SET_APPRAISER_COUNTIES = "REQUEST_SET_APPRAISER_COUNTIES";
export const RECEIVE_SET_APPRAISER_COUNTIES = "RECEIVE_SET_APPRAISER_COUNTIES";
export const ERROR_SET_APPRAISER_COUNTIES = "ERROR_SET_APPRAISER_COUNTIES";

export const REQUEST_COUNTY_BOUNDARIES_LIST = "REQUEST_COUNTY_BOUNDARIES_LIST";
export const RECEIVE_COUNTY_BOUNDARIES_LIST = "RECEIVE_COUNTY_BOUNDARIES_LIST";
export const ERROR_COUNTY_BOUNDARIES_LIST = "ERROR_COUNTY_BOUNDARIES_LIST";
export const CLEAR_COUNTY_BOUNDARIES_LIST = "CLEAR_COUNTY_BOUNDARIES_LIST";

export const CLEAR_ASSIGNMENT_TOOL_MEMORY = "CLEAR_ASSIGNMENT_TOOL_MEMORY";

export const REQUEST_MULTIPLE_APPRAISER_COUNTIES = "REQUEST_MULTIPLE_APPRAISER_COUNTIES";
export const RECEIVE_MULTIPLE_APPRAISER_COUNTIES = "RECEIVE_MULTIPLE_APPRAISER_COUNTIES";
export const ERROR_MULTIPLE_APPRAISER_COUNTIES = "ERROR_MULTIPLE_APPRAISER_COUNTIES";

export const REQUEST_CREATE_USER = "REQUEST_CREATE_USER";
export const RECEIVE_CREATE_USER = "RECEIVE_CREATE_USER";
export const ERROR_CREATE_USER = "ERROR_CREATE_USER";

export const REQUEST_DISABLE_USER = "REQUEST_DISABLE_USER";
export const RECEIVE_DISABLE_USER = "RECEIVE_DISABLE_USER";
export const ERROR_DISABLE_USER = "ERROR_DISABLE_USER";

export const BACKFILL_RCT = "BACKFILL_RCT";
export const BACKFILL_RCT_SUCCESS = "BACKFILL_RCT_SUCCESS";
export const BACKFILL_RCT_ERROR = "BACKFILL_RCT_ERROR";
export const SAVE_RCT_FORM = "SAVE_RCT_FORM";

export const REQUEST_GENERATE_PDF = "REQUEST_GENERATE_PDF";
export const RECEIVE_GENERATE_PDF = "RECEIVE_GENERATE_PDF";
export const ERROR_GENERATE_PDF = "ERROR_GENERATE_PDF";

export const REQUEST_REGENERATE_PDF = "REQUEST_REGENERATE_PDF";
export const RECEIVE_REGENERATE_PDF = "RECEIVE_REGENERATE_PDF";
export const ERROR_REGENERATE_PDF = "ERROR_REGENERATE_PDF";

export const CLEAR_FILTERS = "CLEAR_FILTERS";

export const REQUEST_PROP_RECORD_RESULTS = "REQUEST_PROP_RECORD_RESULTS";
export const RECEIVE_PROP_RECORD_RESULTS = "RECEIVE_PROP_RECORD_RESULTS";
export const ERROR_PROP_RECORD_RESULTS = "ERROR_PROP_RECORD_RESULTS";

export const SIDEBAR_EXPAND = "SIDEBAR_EXPAND";
export const SIDEBAR_CONTRACT = "SIDEBAR_CONTRACT";
export const TOGGLE_ACTIVE_SIDEBAR_MODULE = "TOGGLE_ACTIVE_SIDEBAR_MODULE";

export const REQUEST_360_VALUE = "REQUEST_360_VALUE";
export const RECEIVE_360_VALUE = "RECEIVE_360_VALUE";
export const ERROR_360_VALUE = "ERROR_360_VALUE";

export const REQUEST_E2VALUE = "REQUEST_E2VALUE";
export const RECEIVE_E2VALUE = "RECEIVE_E2VALUE";
export const ERROR_E2VALUE = "ERROR_E2VALUE";

export const CASEALERT_MARKREAD = "CASEALERT_MARKREAD";

export const UPDATE_HEADER = "UPDATE_HEADER";
export const CLEAR_HEADER = "CLEAR_HEADER";
export const APPEND_HEADER = "APPEND_HEADER";
export const CLEAR_HEADER_DEFINITIONS = "CLEAR_HEADER_DEFINITIONS";

export const REQUEST_CASE_ALERTS = "REQUEST_CASE_ALERTS";
export const RECEIVE_CASE_ALERTS = "RECEIVE_CASE_ALERTS";
export const ERROR_CASE_ALERTS = "ERROR_CASE_ALERTS";

export const REQUEST_UPDATE_CASEHEADER = "REQUEST_UPDATE_CASEHEADER";
export const RECEIVE_UPDATE_CASEHEADER = "RECEIVE_UPDATE_CASEHEADER";
export const ERROR_UPDATE_CASEHEADER = "ERROR_UPDATE_CASEHEADER";

export const REQUEST_QA_CASE_INFO = "REQUEST_QA_CASE_INFO";
export const RECEIVE_QA_CASE_INFO = "RECEIVE_QA_CASE_INFO";
export const ERROR_QA_CASE_INFO = "ERROR_QA_CASE_INFO";

export const REQUEST_FR_TEAMLEADERS = "REQUEST_FR_TEAMLEADERS";
export const RECEIVE_FR_TEAMLEADERS = "RECEIVE_FR_TEAMLEADERS";
export const ERROR_FR_TEAMLEADERS = "ERROR_FR_TEAMLEADERS";

export const REQUEST_APPRAISAL_CASE_LOCATIONS_COUNT =
  "REQUEST_APPRAISAL_CASE_LOCATIONS_COUNT";
export const RECEIVE_APPRAISAL_CASE_LOCATIONS_COUNT =
  "RECEIVE_APPRAISAL_CASE_LOCATIONS_COUNT";
export const ERROR_APPRAISAL_CASE_LOCATIONS_COUNT =
  "ERROR_APPRAISAL_CASE_LOCATIONS_COUNT";
export const REQUEST_INSURANCE_CASE_LOCATIONS_COUNT =
  "REQUEST_INSURANCE_CASE_LOCATIONS_COUNT";
export const RECEIVE_INSURANCE_CASE_LOCATIONS_COUNT =
  "RECEIVE_INSURANCE_CASE_LOCATIONS_COUNT";
export const ERROR_INSURANCE_CASE_LOCATIONS_COUNT =
  "ERROR_INSURANCE_CASE_LOCATIONS_COUNT";

export const REQUEST_APPRAISAL_FORM_DATA = "REQUEST_APPRAISAL_FORM_DATA";
export const RECEIVE_APPRAISAL_FORM_DATA = "RECEIVE_APPRAISAL_FORM_DATA";
export const ERROR_APPRAISAL_FORM_DATA = "ERROR_APPRAISAL_FORM_DATA";

export const REQUEST_SAVE_1004P_FORM_DATA = "REQUEST_SAVE_1004P_FORM_DATA";
export const RECEIVE_SAVE_1004P_FORM_DATA = "RECEIVE_SAVE_1004P_FORM_DATA";
export const ERROR_SAVE_1004P_FORM_DATA = "ERROR_SAVE_1004P_FORM_DATA";

export const REQUEST_INSURANCECUSTOMER_GET_CASENFO = "REQUEST_INSURANCECUSTOMER_GET_CASENFO";
export const RESPONSE_INSURANCECUSTOMER_GET_CASENFO = "RESPONSE_INSURANCECUSTOMER_GET_CASENFO";
export const ERROR_INSURANCECUSTOMER_GET_CASENFO = "ERROR_INSURANCECUSTOMER_GET_CASENFO";

export const REQUEST_ASSIGNABLE_APPRAISER_LIST = "REQUEST_ASSIGNABLE_APPRAISER_LIST";
export const RECEIVE_ASSIGNABLE_APPRAISER_LIST = "RECEIVE_ASSIGNABLE_APPRAISER_LIST";
export const ERROR_ASSIGNABLE_APPRAISER_LIST = "ERROR_ASSIGNABLE_APPRAISER_LIST";

export const REQUEST_CHANGE_APPRAISER = "REQUEST_CHANGE_APPRAISER";
export const RECEIVE_CHANGE_APPRAISER = "RECEIVE_CHANGE_APPRAISER";
export const ERROR_CHANGE_APPRAISER = "ERROR_CHANGE_APPRAISER";

export const REQUEST_ADD_CUSTOMER_ACTION = "REQUEST_ADD_CUSTOMER_ACTION";
export const SUCCESS_ADD_CUSTOMER_ACTION = "SUCCESS_ADD_CUSTOMER_ACTION";
export const ERROR_ADD_CUSTOMER_ACTION = "ERROR_ADD_CUSTOMER_ACTION";

export const REQUEST_GET_CUSTOMER_ACTIONS = "REQUEST_GET_CUSTOMER_ACTIONS";
export const SUCCESS_GET_CUSTOMER_ACTIONS = "SUCCESS_GET_CUSTOMER_ACTIONS";
export const ERROR_GET_CUSTOMER_ACTIONS = "ERROR_GET_CUSTOMER_ACTIONS";

export const REQUEST_CUSTOMER_SCORECARD = "REQUEST_CUSTOMER_SCORECARD";
export const RECEIVE_CUSTOMER_SCORECARD = "RECEIVE_CUSTOMER_SCORECARD";
export const ERROR_CUSTOMER_SCORECARD = "ERROR_CUSTOMER_SCORECARD";

export const TOGGLE_WINDOW = "TOGGLE_WINDOW";
export const CLOSE_WINDOW = "CLOSE_WINDOW";

export const UPDATE_QA_REDUX_CASEINFO = "UPDATE_QA_REDUX_CASEINFO";

export const REQUEST_PNX_FORM_EXPORT_DATA = "REQUEST_PNX_FORM_EXPORT_DATA";
export const RECEIVE_PNX_FORM_EXPORT_DATA = "RECEIVE_PNX_FORM_EXPORT_DATA";
export const ERROR_PNX_FORM_EXPORT_DATA = "ERROR_PNX_FORM_EXPORT_DATA";

export const REQUEST_SAVE_PNX_FORM_EXPORT_DATA = "REQUEST_SAVE_PNX_FORM_EXPORT_DATA";
export const RECEIVE_SAVE_PNX_FORM_EXPORT_DATA = "RECEIVE_SAVE_PNX_FORM_EXPORT_DATA";
export const ERROR_SAVE_PNX_FORM_EXPORT_DATA = "ERROR_SAVE_PNX_FORM_EXPORT_DATA";

export const REQUEST_CASE_CONVERSION_OPTIONS = "REQUEST_CASE_CONVERSION_OPTIONS";
export const RECEIVE_CASE_CONVERSION_OPTIONS = "RECEIVE_CASE_CONVERSION_OPTIONS";
export const ERROR_CASE_CONVERSION_OPTIONS = "ERROR_CASE_CONVERSION_OPTIONS";

export const REQUEST_CASE_CONVERSION = "REQUEST_CASE_CONVERSION";
export const RECEIVE_CASE_CONVERSION = "RECEIVE_CASE_CONVERSION";
export const ERROR_CASE_CONVERSION = "ERROR_CASE_CONVERSION";

export const REQUEST_SUBMIT_TO_QA = "REQUEST_SUBMIT_TO_QA";
export const RECEIVE_SUBMIT_TO_QA = "RECEIVE_SUBMIT_TO_QA";
export const ERROR_SUBMIT_TO_QA = "ERROR_SUBMIT_TO_QA";

export const PIN_TYPE_SELECTED_CHANGE = "PIN_TYPE_FILTER_CHANGE";
export const COUNTIES_SELECTED_CHANGE = "COUNTIES_SELECTED_CHANGE";
export const DAYS_OLD_OPTION_SELECTED_CHANGE = "DAYS_OLD_OPTION_SELECTED_CHANGE";
export const DAYS_TILL_DUE_OPTION_SELECTED_CHANGE = "DAYS_TILL_DUE_OPTION_SELECTED_CHANGE";
export const EXTRA_FILTERS_SELECTED_CHANGE = "EXTRA_FILTERS_SELECTED_CHANGE";
export const CASE_ID_FILTER_CHANGE = "CASE_ID_FILTER_CHANGE";
export const SHOW_EXTRA_DETAILS_CHANGE = "SHOW_EXTRA_DETAILS_CHANGE";
export const SELECTION_DETAILS_MODE_CHANGE = "SELECTION_DETAILS_MODE_CHANGE";
export const SELECTED_INSPECTOR_CHANGE = "SELECTED_INSPECTOR_CHANGE";

export const REQUEST_BROKER_BILLING_PREVIEW = "REQUEST_BROKER_BILLING_PREVIEW";
export const RECEIVE_BROKER_BILLING_PREVIEW = "RECEIVE_BROKER_BILLING_PREVIEW";
export const ERROR_BROKER_BILLING_PREVIEW = "ERROR_BROKER_BILLING_PREVIEW";

export const CORELAYOUT_HEADER_VISIBILITY_CHANGE = "CORELAYOUT_HEADER_VISIBILITY_CHANGE";
export const CORELAYOUT_SIDEBAR_VISIBILITY_CHANGE = "CORELAYOUT_SIDEBAR_VISIBILITY_CHANGE";

export const REQUEST_CANCEL_CASE = "REQUEST_CANCEL_CASE";
export const RECEIVE_CANCEL_CASE = "RECEIVE_CANCEL_CASE";
export const ERROR_CANCEL_CASE = "ERROR_CANCEL_CASE";

export const REQUEST_CUSTOMER_SERVICE_ASSIGN_TO_USERS = "REQUEST_CUSTOMER_SERVICE_ASSIGN_TO_USERS";
export const RECEIVE_CUSTOMER_SERVICE_ASSIGN_TO_USERS = "RECEIVE_CUSTOMER_SERVICE_ASSIGN_TO_USERS";
export const ERROR_CUSTOMER_SERVICE_ASSIGN_TO_USERS = "ERROR_CUSTOMER_SERVICE_ASSIGN_TO_USERS";

export const REQUEST_MINIMAL_FIELD_REP_LIST = "REQUEST_MINIMAL_FIELD_REP_LIST";
export const RECEIVE_MINIMAL_FIELD_REP_LIST = "RECEIVE_MINIMAL_FIELD_REP_LIST";
export const ERROR_MINIMAL_FIELD_REP_LIST = "ERROR_MINIMAL_FIELD_REP_LIST";

export const REQUEST_ADD_ATTACHMENT = "REQUEST_ADD_ATTACHMENT";
export const RECEIVE_ADD_ATTACHMENT = "RECEIVE_ADD_ATTACHMENT";
export const ERROR_ADD_ATTACHMENT = "ERROR_ADD_ATTACHMENT";

export const REQUEST_FLC_LIST = "REQUEST_FLC_LIST";
export const RECEIVE_FLC_LIST = "RECEIVE_FLC_LIST";
export const ERROR_FLC_LIST = "ERROR_FLC_LIST";

export const REQUEST_DELETE_ATTACHMENT = "REQUEST_DELETE_ATTACHMENT";
export const RECIEVE_DELETE_ATTACHMENT = "RECIEVE_DELETE_ATTACHMENT";
export const ERROR_DELETE_ATTACHMENT = "ERROR_DELETE_ATTACHMENT";

export const REQUEST_FIELD_REP_DEVELOPMENT_MANAGER_LIST = "REQUEST_FIELD_REP_DEVELOPMENT_MANAGER_LIST";
export const RECEIVE_FIELD_REP_DEVELOPMENT_MANAGER_LIST = "RECEIVE_FIELD_REP_DEVELOPMENT_MANAGER_LIST";
export const ERROR_FIELD_REP_DEVELOPMENT_MANAGER_LIST = "ERROR_FIELD_REP_DEVELOPMENT_MANAGER_LIST";

export const REQUEST_UNDERWRITERS_FOR_USER = "REQUEST_UNDERWRITERS_FOR_USER";
export const RECEIVE_UNDERWRITERS_FOR_USER = "RECEIVE_UNDERWRITERS_FOR_USER";
export const ERROR_UNDERWRITERS_FOR_USER = "ERROR_UNDERWRITERS_FOR_USER";

export const REQUEST_CASE_STEPPER = "REQUEST_CASE_STEPPER";
export const RECEIVE_CASE_STEPPER = "RECEIVE_CASE_STEPPER";
export const ERROR_CASE_STEPPER = "ERROR_CASE_STEPPER";

export const PHOENIX_RCT_NEEDS_COMMIT = "PHOENIX_RCT_NEEDS_COMMIT";

export const REQUEST_APPRAISAL_PORT_HOLD_REASONS = "REQUEST_APPRAISAL_PORT_HOLD_REASONS";
export const RECEIVE_APPRAISAL_PORT_HOLD_REASONS = "RECEIVE_APPRAISAL_PORT_HOLD_REASONS";
export const ERROR_APPRAISAL_PORT_HOLD_REASONS = "ERROR_APPRAISAL_PORT_HOLD_REASONS";

export const REQUEST_MINIMAL_FIELD_REP_LIST_FOR_CASE = "REQUEST_MINIMAL_FIELD_REP_LIST_FOR_CASE";
export const RECEIVE_MINIMAL_FIELD_REP_LIST_FOR_CASE = "RECEIVE_MINIMAL_FIELD_REP_LIST_FOR_CASE";
export const ERROR_MINIMAL_FIELD_REP_LIST_FOR_CASE = "ERROR_MINIMAL_FIELD_REP_LIST_FOR_CASE";

export const REQUEST_GAAR_RESULTS = "REQUEST_GAAR_RESULTS";
export const RECEIVE_GAAR_RESULTS = "RECEIVE_GAAR_RESULTS";
export const ERROR_GAAR_RESULTS = "ERROR_GAAR_RESULTS";

export const REQUEST_CUSTOMER_FEATURES = "REQUEST_CUSTOMER_FEATURES";
export const RECEIVE_CUSTOMER_FEATURES = "RECEIVE_CUSTOMER_FEATURES";
export const ERROR_CUSTOMER_FEATURES = "ERROR_CUSTOMER_FEATURES";

export const REQUEST_APPRAISER_EXCLUSION_SEARCH_RESULTS = "REQUEST_APPRAISER_EXCLUSION_SEARCH_RESULTS";
export const RECEIVE_APPRAISER_EXCLUSION_SEARCH_RESULTS = "RECEIVE_APPRAISER_EXCLUSION_SEARCH_RESULTS";
export const ERROR_APPRAISER_EXCLUSION_SEARCH_RESULTS = "ERROR_APPRAISER_EXCLUSION_SEARCH_RESULTS";

export const REQUEST_ALL_BUS_OPS_DIRECTORS = "REQUEST_ALL_BUS_OPS_DIRECTORS";
export const RECEIVE_ALL_BUS_OPS_DIRECTORS = "RECEIVE_ALL_BUS_OPS_DIRECTORS";
export const ERROR_ALL_BUS_OPS_DIRECTORS = "ERROR_ALL_BUS_OPS_DIRECTORS";

export const REQUEST_ALL_BUS_OPS_MANAGERS = "REQUEST_ALL_BUS_OPS_MANAGERS";
export const RECEIVE_ALL_BUS_OPS_MANAGERS = "RECEIVE_ALL_BUS_OPS_MANAGERS";
export const ERROR_ALL_BUS_OPS_MANAGERS = "ERROR_ALL_BUS_OPS_MANAGERS";

export const REQUEST_FIELD_REP_MANAGERS = "REQUEST_FIELD_REP_MANAGERS";
export const RECEIVE_FIELD_REP_MANAGERS = "RECEIVE_FIELD_REP_MANAGERS";
export const ERROR_FIELD_REP_MANAGERS = "ERROR_FIELD_REP_MANAGERS";

export const REQUEST_INSPECTOR_LIST_SUMMARY = "REQUEST_INSPECTOR_LIST_SUMMARY";
export const RECEIVE_INSPECTOR_LIST_SUMMARY = "RECEIVE_INSPECTOR_LIST_SUMMARY";
export const ERROR_INSPECTOR_LIST_SUMMARY = "ERROR_INSPECTOR_LIST_SUMMARY";

export const USER_WILL_LOGOUT = "USER_WILL_LOGOUT";

export const REQUEST_CUSTOMER_SEARCH_TEXT = "REQUEST_CUSTOMER_SEARCH_TEXT";
export const RECEIVE_CUSTOMER_SEARCH_TEXT = "RECEIVE_CUSTOMER_SEARCH_TEXT";
export const ERROR_CUSTOMER_SEARCH_TEXT = "ERROR_CUSTOMER_SEARCH_TEXT";

export const REQUEST_CUSTOMER_SEARCH_OPTIONS = "REQUEST_CUSTOMER_SEARCH_OPTIONS";
export const RECEIVE_CUSTOMER_SEARCH_OPTIONS = "RECEIVE_CUSTOMER_SEARCH_OPTIONS";
export const ERROR_CUSTOMER_SEARCH_OPTIONS = "ERROR_CUSTOMER_SEARCH_OPTIONS";

export const REQUEST_CUSTOMER_DETAILS = "REQUEST_CUSTOMER_DETAILS";
export const RECEIVE_CUSTOMER_DETAILS = "RECEIVE_CUSTOMER_DETAILS";
export const ERROR_CUSTOMER_DETAILS = "ERROR_CUSTOMER_DETAILS";

export const REQUEST_APPRAISER_ORDER_REQUIREMENTS = "REQUEST_APPRAISER_ORDER_REQUIREMENTS";
export const RECEIVE_APPRAISER_ORDER_REQUIREMENTS = "RECEIVE_APPRAISER_ORDER_REQUIREMENTS";
export const ERROR_APPRAISER_ORDER_REQUIREMENTS = "ERROR_APPRAISER_ORDER_REQUIREMENTS";

export const REQUEST_UPLOAD_APPRAISER_ORDER_REQUIREMENTS = "REQUEST_UPLOAD_APPRAISER_ORDER_REQUIREMENTS";
export const RECEIVE_UPLOAD_APPRAISER_ORDER_REQUIREMENTS = "RECEIVE_UPLOAD_APPRAISER_ORDER_REQUIREMENTS";
export const ERROR_UPLOAD_APPRAISER_ORDER_REQUIREMENTS = "ERROR_UPLOAD_APPRAISER_ORDER_REQUIREMENTS";

export const REQUEST_DELETE_APPRAISER_ORDER_REQUIREMENTS = "REQUEST_DELETE_APPRAISER_ORDER_REQUIREMENTS";
export const RECEIVE_DELETE_APPRAISER_ORDER_REQUIREMENTS = "RECEIVE_DELETE_APPRAISER_ORDER_REQUIREMENTS";
export const ERROR_DELETE_APPRAISER_ORDER_REQUIREMENTS = "ERROR_DELETE_APPRAISER_ORDER_REQUIREMENTS";

export const REQUEST_CASE_HEADER = "REQUEST_CASE_HEADER";
export const RECEIVE_CASE_HEADER = "RECEIVE_CASE_HEADER";
export const ERROR_CASE_HEADER = "ERROR_CASE_HEADER";

export const REQUEST_MINIMAL_APPRAISER_LIST = "REQUEST_MINIMAL_APPRAISER_LIST";
export const RECEIVE_MINIMAL_APPRAISER_LIST = "RECEIVE_MINIMAL_APPRAISER_LIST";
export const ERROR_MINIMAL_APPRAISER_LIST = "ERROR_MINIMAL_APPRAISER_LIST";

export const REQUEST_CASE_LINKS = "REQUEST_CASE_LINKS";
export const RECEIVE_CASE_LINKS = "RECEIVE_CASE_LINKS";
export const ERROR_RETRIEVING_CASE_LINKS = "ERROR_RETRIEVING_CASE_LINKS";

export const REQUEST_ALL_CUSTOMER_ACTIONS_FOR_USER = "REQUEST_ALL_CUSTOMER_ACTIONS_FOR_USER";
export const RECEIVE_ALL_CUSTOMER_ACTIONS_FOR_USER = "RECEIVE_ALL_CUSTOMER_ACTIONS_FOR_USER";
export const ERROR_ALL_CUSTOMER_ACTIONS_FOR_USER = "ERROR_ALL_CUSTOMER_ACTIONS_FOR_USER";

export const REQUEST_FR_EXCLUSION_SEARCH_RESULTS = "REQUEST_FR_EXCLUSION_SEARCH_RESULTS";
export const RECEIVE_FR_EXCLUSION_SEARCH_RESULTS = "RECEIVE_FR_EXCLUSION_SEARCH_RESULTS";
export const ERROR_FR_EXCLUSION_SEARCH_RESULTS = "ERROR_FR_EXCLUSION_SEARCH_RESULTS";

export const REQUEST_ALL_CASE_FORMS = "REQUEST_ALL_CASE_FORMS";
export const RECEIVE_ALL_CASE_FORMS = "RECEIVE_ALL_CASE_FORMS";
export const ERROR_RETRIEVING_ALL_CASE_FORMS = "ERROR_RETRIEVING_ALL_CASE_FORMS";

export const REQUEST_AVAILABLE_CASE_FORMS = "REQUEST_AVAILABLE_CASE_FORMS";
export const RECEIVE_AVAILABLE_CASE_FORMS = "RECEIVE_AVAILABLE_CASE_FORMS";
export const ERROR_RETRIEVING_AVAILABLE_CASE_FORMS = "ERROR_RETRIEVING_AVAILABLE_CASE_FORMS";

export const REQUEST_POST_CASE_FORM = "REQUEST_POST_CASE_FORM";
export const RECEIVE_POST_CASE_FORM = "RECEIVE_POST_CASE_FORM";
export const ERROR_RETRIEVING_POST_CASE_FORM = "ERROR_RETRIEVING_POST_CASE_FORM";

export const REQUEST_DELETE_CASE_FORM = "REQUEST_DELETE_CASE_FORM";
export const RECEIVE_DELETE_CASE_FORM = "RECEIVE_DELETE_CASE_FORM";
export const ERROR_RETRIEVING_DELETE_CASE_FORM = "ERROR_RETRIEVING_DELETE_CASE_FORM";

export const MANAGE_FORMS_DIALOG = "MANAGE_FORMS_DIALOG";

export const REQUEST_RISK_PROFILER_RESULTS = "REQUEST_RISK_PROFILER_RESULTS";
export const RECEIVE_RISK_PROFILER_RESULTS = "RECEIVE_RISK_PROFILER_RESULTS";
export const ERROR_RETRIEVING_RISK_PROFILER_RESULTS = "ERROR_RETRIEVING_RISK_PROFILER_RESULTS";

export const SAVE_COMP_PHOTO_METADATA = "SAVE_COMP_PHOTO_METADATA";

export const FR_GEO_COVERAGE_MODE = "FR_GEO_COVERAGE_MODE";
export const SERVICE_REGION_DRAWN = "SERVICE_REGION_DRAWN";

export const REQUEST_CASE_EXPORT_TYPES = "REQUEST_CASE_EXPORT_TYPES";
export const RECEIVE_CASE_EXPORT_TYPES = "RECEIVE_CASE_EXPORT_TYPES";
export const ERROR_CASE_EXPORT_TYPES = "ERROR_CASE_EXPORT_TYPES";

export const REQUEST_FIELD_DEVELOPMENT_MANAGERS = "REQUEST_FIELD_DEVELOPMENT_MANAGERS";
export const RECEIVE_FIELD_DEVELOPMENT_MANAGERS = "RECEIVE_FIELD_DEVELOPMENT_MANAGERS";
export const ERROR_FIELD_DEVELOPMENT_MANAGERS = "ERROR_FIELD_DEVELOPMENT_MANAGERS";

export const CLEAR_APPRAISER_PROFILE = "CLEAR_APPRAISER_PROFILE";

export const BEGIN_UPDATE_CASE_ISSUES = "BEGIN_UPDATE_CASE_ISSUES";
export const REQ_POST_CASE_ISSUES = "REQ_POST_CASE_ISSUES";
export const RES_POST_CASE_ISSUES = "RES_POST_CASE_ISSUES";
export const ERR_POST_CASE_ISSUES = "ERR_POST_CASE_ISSUES";

export const SET_CALL_CENTER_READY = "SET_CALL_CENTER_READY";
export const SET_CALL_CENTER_CONTROL_NUMBER = "SET_CALL_CENTER_CONTROL_NUMBER";

export const REQUEST_PHOENIX_RCT_CALC = "REQUEST_PHOENIX_RCT_CALC";
export const RECEIVE_PHOENIX_RCT_CALC = "RECEIVE_PHOENIX_RCT_CALC";
export const ERROR_PHOENIX_RCT_CALC = "ERROR_PHOENIX_RCT_CALC";

export const REQUEST_LENDER_LOGISTICS_MANAGERS = "REQUEST_LENDER_LOGISTICS_MANAGERS";
export const RECEIVE_LENDER_LOGISTICS_MANAGERS = "RECEIVE_LENDER_LOGISTICS_MANAGERS";
export const ERROR_LENDER_LOGISTICS_MANAGERS = "ERROR_LENDER_LOGISTICS_MANAGERS";

export const SET_MIDNIGHT = "SET_MIDNIGHT";

export const REQUEST_CASE_HAZARDS = "REQUEST_CASE_HAZARDS";
export const RECEIVE_CASE_HAZARDS = "RECEIVE_CASE_HAZARDS";
export const ERROR_CASE_HAZARDS = "ERROR_CASE_HAZARDS";

export const SET_EXPORT_MESSAGE = "SET_EXPORT_MESSAGE";

export const REQUEST_TRAINING_SECTIONS = "REQUEST_TRAINING_SECTIONS";
export const RECEIVE_TRAINING_SECTIONS = "RECEIVE_TRAINING_SECTIONS";
export const ERROR_TRAINING_SECTIONS = "ERROR_TRAINING_SECTIONS";

export const REQUEST_OPERATIONS_MANAGERS = "REQUEST_OPERATIONS_MANAGERS";
export const RECEIVE_OPERATIONS_MANAGERS = "RECEIVE_OPERATIONS_MANAGERS";
export const ERROR_OPERATIONS_MANAGERS = "ERROR_OPERATIONS_MANAGERS";

export const SET_CURRENT_QUICKLIST_ID = "SET_CURRENT_QUICKLIST_ID";
export const SET_CURRENT_QUICKLIST_ROW_INDEX = "SET_CURRENT_QUICKLIST_ROW_INDEX";

export const RESET_QA_CASE = "RESET_QA_CASE";

export const REQUEST_SCHEDULING_USERS = "REQUEST_SCHEDULING_USERS";
export const RECEIVE_SCHEDULING_USERS = "RECEIVE_SCHEDULING_USERS";
export const ERROR_SCHEDULING_USERS = "ERROR_SCHEDULING_USERS";

export const SET_SELECTED_SURVEY_TYPE = "SET_SELECTED_SURVEY_TYPE";
export const SET_SELECTED_CUSTOMER = "SET_SELECTED_CUSTOMER";

export const REQUEST_QA_ASSIGNABLE_USERS = "REQUEST_QA_ASSIGNABLE_USERS";
export const RECEIVE_QA_ASSIGNABLE_USERS = "RECEIVE_QA_ASSIGNABLE_USERS";
export const ERROR_QA_ASSIGNABLE_USERS = "ERROR_QA_ASSIGNABLE_USERS";

export const REQUEST_CUSTOMER_FORMS = "REQUEST_CUSTOMER_FORMS";
export const RECEIVE_CUSTOMER_FORMS = "RECEIVE_CUSTOMER_FORMS";
export const ERROR_CUSTOMER_FORMS = "ERROR_CUSTOMER_FORMS";

export const SET_QA_TIMER_INFO = "SET_QA_TIMER_INFO";

export const REQUEST_NOTIFICATION_TYPES = "REQUEST_NOTIFICATION_TYPES";
export const RECEIVE_NOTIFICATION_TYPES = "RECEIVE_NOTIFICATION_TYPES";
export const ERROR_NOTIFICATION_TYPES = "ERROR_NOTIFICATION_TYPES";

export const REQUEST_NOTIFICATION_METHODS = "REQUEST_NOTIFICATION_METHODS";
export const RECEIVE_NOTIFICATION_METHODS = "RECEIVE_NOTIFICATION_METHODS";
export const ERROR_NOTIFICATION_METHODS = "ERROR_NOTIFICATION_METHODS";

export const REQUEST_NOTIFICATION_LETTERS = "REQUEST_NOTIFICATION_LETTERS";
export const RECEIVE_NOTIFICATION_LETTERS = "RECEIVE_NOTIFICATION_LETTERS";
export const ERROR_NOTIFICATION_LETTERS = "ERROR_NOTIFICATION_LETTERS";

export const REQUEST_APPOINTMENT_CANDIDATES = "REQUEST_APPOINTMENT_CANDIDATES";
export const RECEIVE_APPOINTMENT_CANDIDATES = "RECEIVE_APPOINTMENT_CANDIDATES";
export const ERROR_APPOINTMENT_CANDIDATES = "ERROR_APPOINTMENT_CANDIDATES";
export const CLEAR_APPOINTMENT_CANDIDATES = "CLEAR_APPOINTMENT_CANDIDATES";
export const SET_APPOINTMENT_CONTROL_NUMBER = "SET_APPOINTMENT_CONTROL_NUMBER";

export const REQUEST_QA_EMPLOYEES_BY_PAYPERIOD = "REQUEST_QA_EMPLOYEES_BY_PAYPERIOD";
export const RECEIVE_QA_EMPLOYEES_BY_PAYPERIOD = "RECEIVE_QA_EMPLOYEES_BY_PAYPERIOD";
export const CLEAR_QA_EMPLOYEES_BY_PAYPERIOD = "CLEAR_QA_EMPLOYEES_BY_PAYPERIOD";
export const ERROR_QA_EMPLOYEES_BY_PAYPERIOD = "ERROR_QA_EMPLOYEES_BY_PAYPERIOD";

export const REQUEST_CUSTOMER_EXPERIENCE_MANAGERS = "REQUEST_CUSTOMER_EXPERIENCE_MANAGERS";
export const RECEIVE_CUSTOMER_EXPERIENCE_MANAGERS = "RECEIVE_CUSTOMER_EXPERIENCE_MANAGERS";
export const ERROR_CUSTOMER_EXPERIENCE_MANAGERS = "ERROR_CUSTOMER_SERVICE_MANAGERS";

export const REQUEST_CUSTOMER_EXPERIENCE_DIRECTORS = "REQUEST_CUSTOMER_EXPERIENCE_DIRECTORS";
export const RECEIVE_CUSTOMER_EXPERIENCE_DIRECTORS = "RECEIVE_CUSTOMER_EXPERIENCE_DIRECTORS";
export const ERROR_CUSTOMER_EXPERIENCE_DIRECTORS = "ERROR_CUSTOMER_EXPERIENCE_DIRECTORS";

export const REQUEST_ACTIVE_UNDERWRITERS_FOR_USER = "REQUEST_ACTIVE_UNDERWRITERS_FOR_USER";
export const RECEIVE_ACTIVE_UNDERWRITERS_FOR_USER = "RECEIVE_ACTIVE_UNDERWRITERS_FOR_USER";
export const ERROR_ACTIVE_UNDERWRITERS_FOR_USER = "ERROR_ACTIVE_UNDERWRITERS_FOR_USER";
